import React from 'react';
import styled from 'styled-components/macro';

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      didError: false,
    };
  }

  componentDidCatch() {
    this.setState({ didError: true });
  }

  render() {
    if (this.state.didError) {
      return (
        <ErrorContainer>
          <p>Ha ocurrido un error al cargar el mapa</p>
          <p>Recargue la página.</p>
        </ErrorContainer>
      );
    }
    return this.props.children;
  }
}

const ErrorContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 30vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  box-sizing: border-box;
  & > p {
    font-size: 2rem;
    text-align: center;
  }
`;

export default MapErrorBoundary;
